import './Signup.scss';
import Checkbox from '../utils/Checkbox';
import gmailLogo from '../../images/gmail.png'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import CustomPasswordField from '../utils/CustomPasswordField';

function Signup() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    return (
        <div className='signup-wrp'>
            <div className='signup-title'>Sign Up For Free</div>
            {/* <div className='joining-bonus-wrp'>
                <span className='bonus-amount'>Rs. 500/-</span> Instant Joining Bonus <br></br> Start Working Right Now
            </div> */}
            < div className='login-options-wrp'>
                <div className='login-with-gmail-wrp'>
                    <img className='gmail-logo' src={gmailLogo} alt="gmail-logo" />
                    <div className='login-txt'>Login With Gmail</div>
                </div>
                <div className='login-option-divider'>
                    <div>Or</div>
                </div>
            </div>
            <form className='signup-login-wrp'>
                <div className='input-container'>
                    <div className='input-label'>Name</div>
                    <input type="text" value={name} defaultValue="" name='name' onChange={(e) => setName(e.target.value)} required></input>
                </div>
                <div className='input-container'>
                    <div className='input-label'>E-mail</div>
                    <input type="text" value={email} defaultValue="" name='email' onChange={(e) => setEmail(e.target.value)} required></input>
                </div>

                <div className='input-container'>
                    <div className='input-label'>Password</div>
                    <CustomPasswordField name='password' value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <div className='terms-wrp'>
                    <div className='accept-input'>
                        <Checkbox name='accept-terms' checked={remember} label={<div><span className='text'>I Accept The </span><Link reloadDocument={true} to="#">Terms & Condition</Link></div>}
                            onChange={(e) => setRemember(e.target.checked)}
                        />
                    </div>
                </div>
                <div className='login-options-wrp'>
                    <input className='login-with-email' type="submit" name="login-with-email" value='Sign Up' />
                    <div className="msg">
                        Already have an account?{" "}
                        <Link reloadDocument={true} to="/login">
                            <span>Login</span>
                        </Link>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default Signup;